import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

export const ChallengeListBackgroundImage = styled.div`
  background-image: url(${({ theme }) => theme.communityList.backgroundImage});
  background-size: cover;
  background-position: center center;
  position: absolute;
  width: 100%;
  height: 740px;
`;

export const HeaderAndContentContainer = styled.div`
  margin-top: 100px;
  margin-bottom: 70px;
  text-align: center;
  color: ${({ theme }) => theme.communityList.selectedColor};
`;

export const Header = styled.div`
  line-height: 77.28px;
  font-weight: 400;
  font-size: 48px;
  text-transform: capitalize;
`;

export const HeaderContent = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 24px;
  letter-spacing: 1px;
`;

export const Icon = styled.i.attrs(({ icon }) => ({ className: icon }))`
  margin-right: 5px;
`;

export const CreateButton = styled(RouterLink)`
  appearance: button;
  color: ${({ theme }) => theme.button.label};
  background: ${({ theme }) => theme.button.background};
  border: 1px solid ${({ theme }) => theme.button.border};
  min-width: 250px;
  max-width: 364px;
  margin-top: 20px;
  padding: 10px 0;
  cursor: pointer;
  border-radius: 28px;
  letter-spacing: 1px;
  font-weight: 600;
  font-size: 20px;

  &:hover {
    text-decoration: none;
    background: ${({ theme }) => theme.button.backgroundHover};
    border: 1px solid ${({ theme }) => theme.button.borderHover};
    color: ${({ theme }) => theme.button.label};
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const DropdownAndSearchContainer = styled.div`
  display: flex;
  @media (max-width: 576px) {
    flex-direction: column;
    gap: 10px;
  }
`;
